import { Story } from '../Entities/Stories/stories.reducer';
import actionCreatorFactory from 'typescript-fsa';
import { ClusterEdit } from './cluster-edit.reducer';
import { Dictionary } from 'ramda';
import { ClusterImage } from '../../modules/ClusterEdit';

const actionCreator = actionCreatorFactory('ClusterEdit');

export const fetchClusterById = actionCreator<{
  clusterId: number;
}>('CLUSTER_FETCH');

export const updateClusterEdit = actionCreator<{
  cluster: ClusterEdit;
}>('UPDATE');

export type textTypes = 'headline' | 'subline' | 'text';

export const updateClusterEditText = actionCreator<{
  type: textTypes;
  language: string;
  text: string;
}>('TEXT_UPDATE');

export const updateClusterEditName = actionCreator<{ name: string }>(
  'NAME_UPDATE'
);

export const updateClusterEditImage = actionCreator<{ images: { data: ClusterImage[] } }>(
  'IMAGES_UPDATE'
);

export const toggleIsFeaturedCluster = actionCreator<{
  countryShortCode: string;
}>('TOGGLE_IS_FEATURED_CLUSTER');

export const updateActivePeriod = actionCreator<{
  countryShortCode: string;
  period: { activeFrom: string | null; activeTo: string | null };
}>('UPDATE_ACTIVE_PERIOD');

export const updateGender = actionCreator<{ gender: 'female' | 'male' }>(
  'UPDATE_GENDER'
);

export const updateType = actionCreator<{
  type: 'default' | 'occasion' | 'bodyType' | 'bas' | 'swimwear' | 'kids' | 'curvy' | 'sport' | 'static' | 'beauty'
}>(
    'UPDATE_TYPE'
);

export const setClusterEditStories = actionCreator<{ stories: Story[] }>(
  'STORIES_SET'
);

export const updateClusterEditStories = actionCreator<{
  stories: number[] | Dictionary<number>;
}>('STORIES_UPDATE');

export const removeClusterEditStory = actionCreator<{
  story: Story;
}>('STORY_REMOVE');

export const submitClusterEdit = actionCreator('SUBMIT');

export const resetClusterEdit = actionCreator('RESET');

export const showClusterEditLoading = actionCreator('LOADING_SHOW');
export const hideClusterEditLoading = actionCreator('LOADING_HIDE');

export const deleteCluster = actionCreator<number>('DELETE_CLUSTER');

export const reOrderClusterEditStories = actionCreator<Story[]>(
  'REORDER_STORIES'
);



// WEBPACK FOOTER //
// ./src/store/ClusterEdit/cluster-edit.actions.ts